import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { t } from '../../../../locales';
import './styles.scss';

import VhisRules from '../VhisRules';

interface PremiumRebateModalViewProps {
  isShowModal: boolean;
  onHideModal: () => void;
  ruleType?: 'SH' | 'WGP';
}

class PremiumRebateModalView extends Component<PremiumRebateModalViewProps> {
  render() {
    const { isShowModal, onHideModal, ruleType } = this.props;

    return (
      <div className="premium-rebate-modal">
        <Modal show={isShowModal} onHide={onHideModal}>
          <ModalHeader>
            {t(
              ruleType === 'SH'
                ? 'SH_PREMIUM_REBATE_MODAL_TITLE'
                : 'PREMIUM_REBATE_MODAL_TITLE',
            )}
          </ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-center">
              <div className="d-line-block">
                <VhisRules ruleType={ruleType} />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="emma-stylesheet-primary-default-button"
              onClick={onHideModal}
              data-enable-ga
              data-ga-type="button"
            >
              {t('PREMIUM_REBATE_MODAL_OK_BTN')}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default PremiumRebateModalView;
